/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { createPage, createFlow } from '../utils';
import { MALE } from '../../gender';
import i18n from '../../../plugins/i18n';
import { REPEAT } from '../variables';
import { APPOINTMENT_TYPES } from '../../appointment';
import { NODE_ENV } from '../../env';

import { FIRST_NAME, LAST_NAME, DATE_OF_BIRTH, GENDER, PRIMARY_COMPLAINT } from '../../store';

const locations = {
  DEV: 'ces9bUzg9e1BhKDnOayR',
  QA: 'ONY1X4tdF1oWlVd3TXUS',
  PROD: 'nD5GgiKjpZ1Dyeo6io5S',
};

const userLocation =
  NODE_ENV === 'development' ? locations.DEV : NODE_ENV === 'qa' ? locations.QA : locations.PROD;

const RegisterIntroduce = createPage({
  name: 'RegisterIntroduce',
  nextPage: 'RegisterInform',
  options: {
    pageConfig: {
      healthCardExpiryOptional: true,
      isAddressOptional: false,
      isEmailOptional: true,
      showGender: true,
      showEmail: true,
      showAddress: true,
      pageTitle: 'Please, tell us a bit about yourself',
      patientData: {
        gender: MALE,
      },
    },
  },
});
const RegisterInform = createPage({
  name: 'RegisterInform',
  nextPage: 'RegisterSchedule',
  options: {
    pageConfig: {
      init: (store, route) => {
        store.commit('setRegistration', {
          appointmentType: APPOINTMENT_TYPES.inPerson,
        });
        // Set default answer to three questions to 'false'
        store.commit('addDefaultPatientNotes', {
          basicNotes: [
            'Has had annual checkup?: false',
            'Specialist Requested: false',
            'Do you have a family physician?: false',
          ],
        });

        const availableEmployees =
          route.query?.e?.split('-') ||
          (store?.state?.registration?.employeeId && [store?.state?.registration?.employeeId]) ||
          [];

        if (availableEmployees?.length) store.commit('setRegistration', { availableEmployees });
      },
      enabledAppointmentTypes: [APPOINTMENT_TYPES.inPerson],
      appendToPrimaryComplaint: 'WALK-IN',
      appointmentReasons: [
        'Cold/Flu/Respiratory Illness',
        'Skin rash',
        'Ear Pain/Discharge',
        'High Blood Pressure',
        'Mental Health',
        'Back Pain',
        'Headache/fever',
        'Need Bloodwork Requisition',
        'Pink Eye',
        'Prescription Renewal',
      ],
      appointmentType: APPOINTMENT_TYPES.inPerson,
      isReasonForVisitFixed: false,
      reasonForVisit: '',
      pageTitle: 'Please tell us how we can help you',
      pageSubtitle:
        'Please describe your medical condition in detail. If we do not have enough information we may call you to gather additional details.',
      form: {
        questionOne: {
          variableName: 'annualCheckup',
          displayText: null,
          noteLabel: 'Has had annual checkup?',
          infoText: null,
          show: true,
          value: false,
        },
        questionTwo: {
          variableName: 'seeSpecialist',

          displayText: null,
          noteLabel: 'Specialist Requested',
          show: true,
          value: null,
        },
        questionThree: {
          variableName: 'hasFamilyPhysician',
          displayText: null,
          noteLabel: 'Do you have a family physician?',
          infoText: null,
          show: true,
          value: false,
        },
      },
    },
  },
});

const skills = {
  DEV: ['1dEVI9d0bHmWIVne43Yi'],
  QA: ['zAaEC7QNNOIDVwaXRYQS'],
  PROD: ['TfKBUxbnXpatzW3EZE98'],
};
const RegisterSchedule = createPage({
  name: 'RegisterSchedule',
  nextPage: 'RegisterSurvey',
  options: {
    pageConfig: {
      // eslint-disable-next-line no-unused-vars
      init: async (store) => {
        if (!store) return;

        const tenantUrl = store.state.registration.tenantUrl || localStorage.tenantUrl;
        if (NODE_ENV === 'development' && tenantUrl === 'demo') {
          store.commit('setRegistration', { appointmentSkills: skills.DEV });
        } else if (NODE_ENV === 'qa' && tenantUrl === 'demo') {
          store.commit('setRegistration', { appointmentSkills: skills.QA });
        } else if (NODE_ENV === 'production' && tenantUrl === 'demo') {
          store.commit('setRegistration', { appointmentSkills: skills.PROD_DEMO });
        } else if (NODE_ENV === 'production' && tenantUrl === 'sentry-health') {
          store.commit('setRegistration', { appointmentSkills: skills.PROD });
        }
      },
      allowAppointmentRequest: false,
      appointmentDuration: 15,
      pageTitle: 'Please select an appointment time',
      pageSubtitle: ' ',
      onlyToday: true,
      showTimezone: false,
      locationId: userLocation,
    },
  },
});

const RegisterSurvey = createPage({
  name: 'RegisterSurvey',
  nextPage: 'RegisterComplete',
  options: {
    backButtonHeader: true,
    pageConfig: {
      pageTitle: '',
      pageSubtitle: '',
      init: async (store) => {
        // const SANDBOX_FORM = 'DdG7s79HfIACxD2Y2avJ';

        const QA_FORM = '5WMvo4HSJnI0tfbmIsWa';

        const PROD_FORM = 'fBBxFJ1gw6cTnAFVPkUb';

        const sourceUrl = window.location.href;

        let form;

        if (/portal.sentryhealth.ca/g.test(sourceUrl)) {
          form = PROD_FORM;
        } else if (/portal.qa.sentryhealth.dev/g.test(sourceUrl)) {
          form = QA_FORM;
        } else {
          //   form = SANDBOX_FORM[tenantUrl];
          form = QA_FORM;
        }

        await store.commit('setRegistration', { form });
      },
      onSurveyCreate: (state, survey) => {
        // eslint-disable-next-line no-param-reassign
        survey.data = {
          ...survey.data,
          firstName: FIRST_NAME(state),
          lastName: LAST_NAME(state),
          gender: GENDER(state),
          primaryComplaint: PRIMARY_COMPLAINT(state),
          dateOfBirth: DATE_OF_BIRTH(state),
        };
      },
      showEndSplash: false,
    },
  },
});

const attributes = {
  DEV: ['q1BLEJBe4mRf4ULtuGol'],
  QA: ['FlA4GTQOWwZpe6JShGc4'],
  PROD: ['dFk13FLUKCCXpbBmKPBw'],
};

const RegisterComplete = createPage({
  name: 'RegisterComplete',
  nextPage: 'RegisterLogout',
  options: {
    pageConfig: {
      checkForExistingUser: true,
      init: async (store, _, vm) => {
        const { appointmentTime } = store.state.registration;
        vm.cardText = i18n.t('registration.registerComplete.walkin.cardText');
        vm.onSuccess = () => {
          if (!appointmentTime) return;
          vm.cardTitle = i18n.t('registration.registerComplete.walkin.cardTitle', {
            date: i18n.t('format.prettyDateLong', { date: appointmentTime.unix() }),
          });
        };

        if (!store) return;

        if (NODE_ENV === 'development') {
          store.commit('setRegistration', {
            memberAttributes: [...attributes.DEV],
          });
          store.commit('setLocation', { id: locations.DEV });
        } else if (NODE_ENV === 'qa') {
          store.commit('setRegistration', {
            memberAttributes: [...attributes.QA],
          });
          store.commit('setLocation', { id: locations.QA });
        } else if (NODE_ENV === 'production') {
          store.commit('setRegistration', {
            memberAttributes: [...attributes.PROD],
          });
          // Virtual clinic
          store.commit('setLocation', { id: locations.PROD });

          if (store.registration.tenantUrl === 'sentry-health') {
            // eslint-disable-next-line no-undef, camelcase
            if (!gtag_report_conversion) {
              console.warn('gtag_report_conversion is not defined');
            } else {
              // eslint-disable-next-line no-undef
              gtag_report_conversion();
            }
          }
        }
      },
      buttonText: i18n.t('main.continue'),
      cardText: i18n.t('registration.registerComplete.defaultFlow.cardText'),
      cardTitle: i18n.t('registration.registerComplete.trt.cardTitle'),
      clickToContinue: true,
      isEndOfRegistration: true,
    },
  },
});

const RegisterLogout = createPage({
  name: 'RegisterLogout',
  nextPage: REPEAT,
  options: {
    clearHistory: true,
  },
});

const anova = createFlow({
  landing: 'RegisterIntroduce',
  theme: 'sentry',
  onError: 'RegisterIntroduce',
  flow: {
    RegisterIntroduce,
    RegisterInform,
    RegisterSchedule,
    RegisterSurvey,
    RegisterComplete,
    RegisterLogout,
  },
});

export default anova;
